// extracted by mini-css-extract-plugin
export default {"container":"index_container__G970K","customTableHeader":"index_customTableHeader__zfPYE","headerItem":"index_headerItem__LBCKg","tableContainer":"index_tableContainer__R-rQB"};